import styled from "styled-components";

export const Page = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  overflow-y: hidden;
`;
